import { render } from "./SmsDetail.vue?vue&type=template&id=69046a58&scoped=true"
import script from "./SmsDetail.vue?vue&type=script&lang=js"
export * from "./SmsDetail.vue?vue&type=script&lang=js"

import "./SmsDetail.vue?vue&type=style&index=0&id=69046a58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69046a58"]])

export default __exports__